import { useForm } from '../useForm';
export var useTextField = function useTextField(_ref) {
  var icon = _ref.icon,
      onClear = _ref.onClear,
      validationStatus = _ref.validationStatus,
      id = _ref.id,
      size = _ref.size;

  var _useForm = useForm({
    id: id,
    validationStatus: validationStatus,
    size: size
  }),
      componentStatus = _useForm.componentStatus,
      componentId = _useForm.componentId,
      componentSize = _useForm.componentSize,
      error = _useForm.error;

  var hasLeftIcon = !!icon;
  var hasClearIcon = !!onClear;
  return {
    componentSize: componentSize,
    componentStatus: componentStatus,
    componentId: componentId,
    error: error,
    hasLeftIcon: hasLeftIcon,
    hasClearIcon: hasClearIcon
  };
};